<template>
	<div class="qksm qksm3">
		<h4>三、支出决算情况说明</h4>
		<div class="nogap">
			<p><b>（一）支出决算结构情况</b></p>
			<p>
				本年支出合计{{isMoney(T3.总计)}}万元，其中：
				<template v-for="(item, idx) in T3.项目">
					{{item.name}}{{isMoney(item.value)}}万元，占{{getPercentValue(T3.项目.map(e=>e.value), idx, 2)}}{{idx==T3.项目.length-1?'。':'；'}}
				</template>
			</p>
		</div>
		<div id="myChart3" class="echart" v-if="!isPdf && $parent.isData"></div>
		<div id="myChart3" class="echart" v-if="isPdf"></div>
		<div class="nogap">
			<p><b>（二）支出决算具体情况</b></p>
			<p v-for="(item, idx) in T3.项目">
				{{idx+1}}、{{item.name}}{{isMoney(item.value)}}万元。
				<span class="hide_pdf">
					（去年决算数<reason type="money" classname="qksm money nullable editLast" :name="item.name+'去年'" v-model:value="qksm[item.name+'去年']"></reason>万元）
				</span>
				<span v-if="num(item.value).toFixed(2)==num(qksm[item.name+'去年']).toFixed(2)">
					与2020年决算数相同。
				</span>
				<span v-else>
					与2020年度相比，{{growthValueText(item.value,qksm[item.name+'去年'])}}万元，
					<span v-if="item.value!=qksm[item.name+'去年'] && num(qksm[item.name+'去年'])!=0">
						{{growthRatioText(item.value,qksm[item.name+'去年'])}}。
					</span>
					主要是<reason type="textarea" classname="qksm widest because" :name="item.name+'原因'" v-model:value="qksm[item.name+'原因']"
							   :placeholder="num(item.value) < num(qksm[item.name+'去年'])? '……减少' : '……增加'"></reason>
				</span>
			</p>
		</div>

	</div>
</template>
<script>
	import reason from "@/components/reason.vue";
	export default {
		name: "qksm3",
		data() {
			var qksm = this.$store.state.divData.qksm
			for (let a of this.T3.项目) {
				qksm[a.name + '去年'] = this.pickOneOf(qksm[a.name + '去年'], a.value_js)
			}
			return {
				isPdf: this.$parent.isPdf,
				qksm: qksm,
			}
		},
		props: {
			T3: {
				type: Object,
				default: "",
			},
		},
		components: {
			reason,
		},
	};
</script>